var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.02734,
    y: 6.24902,
    width: 8.0498,
    height: 7.41211,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99902 2.18164C4.86652 2.18164 1.49902 5.54914 1.49902 9.68164C1.49902 13.8141 4.86652 17.1816 8.99902 17.1816C13.1315 17.1816 16.499 13.8141 16.499 9.68164C16.499 5.54914 13.1315 2.18164 8.99902 2.18164ZM11.519 11.4066C11.7365 11.6241 11.7365 11.9841 11.519 12.2016C11.4065 12.3141 11.264 12.3666 11.1215 12.3666C10.979 12.3666 10.8365 12.3141 10.724 12.2016L8.99902 10.4766L7.27402 12.2016C7.16152 12.3141 7.01902 12.3666 6.87652 12.3666C6.73402 12.3666 6.59152 12.3141 6.47902 12.2016C6.26152 11.9841 6.26152 11.6241 6.47902 11.4066L8.20402 9.68164L6.47902 7.95664C6.26152 7.73914 6.26152 7.37914 6.47902 7.16164C6.69652 6.94414 7.05652 6.94414 7.27402 7.16164L8.99902 8.88664L10.724 7.16164C10.9415 6.94414 11.3015 6.94414 11.519 7.16164C11.7365 7.37914 11.7365 7.73914 11.519 7.95664L9.79402 9.68164L11.519 11.4066Z",
    fill: "#C8C7CF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.6d2087586e97e8fa6558e852240283e0.svg";
export { ForwardRef as ReactComponent };